// extracted by mini-css-extract-plugin
export var back = "Betslip-module--back--8abe6";
export var blue = "#0eb3f2";
export var button = "Betslip-module--button--6301e";
export var buttons = "Betslip-module--buttons--84e82";
export var clamp = "Betslip-module--clamp--2efc7";
export var close = "Betslip-module--close--99e22";
export var container = "Betslip-module--container--6d56d";
export var content = "Betslip-module--content--cd6f2";
export var emphasis = "Betslip-module--emphasis--ba554";
export var entries = "Betslip-module--entries--f7706";
export var entryButtons = "Betslip-module--entryButtons--05727";
export var entryMessage = "Betslip-module--entryMessage--4cdf7";
export var eventName = "Betslip-module--eventName--a531c";
export var exoticTitle = "Betslip-module--exoticTitle--df7fc";
export var footer = "Betslip-module--footer--a58c2";
export var green = "#57d33b";
export var greenLink = "Betslip-module--green-link--67075";
export var grey = "var(--tone-mid)";
export var header = "Betslip-module--header--c7dd3";
export var hidden = "Betslip-module--hidden--3dabb";
export var icon = "Betslip-module--icon--fc974";
export var iconButton = "Betslip-module--iconButton--8e490";
export var info = "Betslip-module--info--df382";
export var isReviewing = "Betslip-module--isReviewing--b5afc";
export var label = "Betslip-module--label--0e9b8";
export var largeFooter = "Betslip-module--largeFooter--76da0";
export var marketName = "Betslip-module--marketName--4fba9";
export var notchGap = "32px";
export var orange = "#f8662b";
export var outcomeIcon = "Betslip-module--outcomeIcon--f8763";
export var panel = "Betslip-module--panel--60bc3";
export var quickBalance = "Betslip-module--quickBalance--53b0d";
export var red = "#ff2741";
export var right = "Betslip-module--right--b19a4";
export var scrollArea = "Betslip-module--scrollArea--5b732";
export var selectionName = "Betslip-module--selectionName--a575a";
export var small = "Betslip-module--small--f1372";
export var smallFooter = "Betslip-module--smallFooter--af201";
export var tab = "Betslip-module--tab--3c5af";
export var tabList = "Betslip-module--tabList--efce4";
export var tabListContainer = "Betslip-module--tabListContainer--3922e";
export var tabs = "Betslip-module--tabs--667a9";
export var title = "Betslip-module--title--a53a7";
export var trash = "Betslip-module--trash--74982";
export var value = "Betslip-module--value--71aa0";
export var viewport = "Betslip-module--viewport--60251";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";